<template>
  <div class="widget_appointment_calendar">
    <div class="calendar-option">
      <button class="btn btn-minus" @click="prevWeek()">
        <img src="@/assets/images/icons/curret_left_black.svg" />
      </button>
      <button class="btn btn-plus" @click="nextWeek()">
        <img src="@/assets/images/icons/curret_right_black.svg" />
      </button>
    </div>
    <div class="calendar-preview">
      <div class="day-column" v-for="(item, i) in calendar" :key="i">
        <div class="dat-info">
          <div class="day-name">{{ item.day_name }}</div>
          <div class="day-month">{{ item.month_name }}</div>
        </div>
        <div
          class="dat-hour"
          v-for="(hour, index) in item.day_hours"
          :key="index"
          @click="selectHour(hour)"
        >
          <span v-if="hour.active">{{ hour.hour }}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_appointment_calendar",
  props: {},
  data() {
    return {
      calendar: [],
      week: 1,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.genelateCalendar(vm.week);
  },
  methods: {
    prevWeek() {
      let vm = this;
      vm.week -= 7;
      vm.genelateCalendar(vm.week);
    },
    nextWeek() {
      let vm = this;
      vm.week += 7;
      vm.genelateCalendar(vm.week);
    },
    genelateCalendar(start) {
      let vm = this;
      let calendar = [];
      for (let day = start; day < start + 7; day++) {
        let date_obj = vm.moment().day(day);
        let date = {
          day_name: date_obj.format("ddd"),
          month_name: date_obj.format("MMM DD"),
          day_hours: [
            {
              active: vm.validateHour(date_obj, 8),
              hour: vm.getHour(date_obj, 8).format("HH:00"),
              full_date: vm.getHour(date_obj, 8).format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 9),
              hour: vm.getHour(date_obj, 9).format("HH:00"),
              full_date: vm.getHour(date_obj, 9).format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: false, // Note: Update this code
              hour: vm.getHour(date_obj, 10).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 10)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 11),
              hour: vm.getHour(date_obj, 11).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 11)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 12),
              hour: vm.getHour(date_obj, 12).format("HH:00"),
              full_date: vm.getHour(date_obj, 12).format("YYYY-MM-DDTHH:00:Z"),
            },
            {
              active: vm.validateHour(date_obj, 13),
              hour: vm.getHour(date_obj, 13).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 13)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 14),
              hour: vm.getHour(date_obj, 14).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 14)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 15),
              hour: vm.getHour(date_obj, 15).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 15)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 16),
              hour: vm.getHour(date_obj, 16).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 16)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
            {
              active: vm.validateHour(date_obj, 17),
              hour: vm.getHour(date_obj, 17).format("HH:00"),
              full_date: vm
                .getHour(date_obj, 17)
                .format("YYYY-MM-DDTHH:00:00Z"),
            },
          ],
        };
        calendar.push(date);
      }
      vm.calendar = calendar;
    },
    validateHour(date_obj, hour) {
      let vm = this;
      //   Note: update this code
      vm.moment(date_obj).hour(hour);
      return true;
    },
    getHour(date_obj, hour) {
      let vm = this;
      let datetime = vm.moment(date_obj).hour(hour);
      return datetime;
    },
    selectHour(hour) {
      let vm = this;
      vm.$emit("input", hour.full_date);
      vm.$emit("change", hour.full_date);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget_appointment_calendar {
  padding: 12px 0px;
  border-radius: 5px;
  border: none;
  font-style: bold !important;
  font-weight: 500;
  width: 100%;
  position: relative;
  cursor: pointer;
  .calendar-option {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .btn {
      height: 35px;
      width: 35px;
      background: #f8f9fa;
      border-radius: 5px;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        opacity: 0.8;
      }
      img {
        width: 6px;
      }
    }
  }
  .calendar-preview {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .day-column {
      width: 13%;
      .dat-info {
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .day-name {
          color: #435f71;
          font-size: 15px;
        }
        .day-month {
          color: #435f71;
          font-size: 11px;
        }
      }
      .dat-hour {
        height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        border-radius: 5px;
        background: rgba(0, 101, 225, 0.1);
        margin-top: 10px;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
